import { useAppContext } from '../../../Services/AppContext';

export const locales: Record<string, string> = {
	default: 'cs-CZ',
	peru: 'es-PE',
	ecuador: 'es-EC',
	mexico: 'es-MX',
	colombia: 'es-CO',
	slovakia: 'sk-SK',
	czechia: 'cs-CZ',
};

export default function usePrice() {
	const { currency, globalTemplate } = useAppContext();

	const formatter: Intl.NumberFormat = new Intl.NumberFormat(
		locales[globalTemplate] ?? undefined,
		{
			style: 'currency',
			currency: currency,
		},
	);

	const formattedPriceString = (price: number) =>
		formatter.format(price).replace(/^(\D+)/, '');

	return { formattedPriceString };
}
